import Logo from '../../Common/Logo';
import MainNav from '../Menu/MainNav';
import Account from '../Account';
import Icons from '../../../../components/Common/Icons/Icons';
import { useMenuContextProvider } from '../../../context/menu';
import Banner from '../../Common/Banners';

export default function Sidebar() {
  const { toggleMenu } = useMenuContextProvider();

  return (
    <div
      className="lg:w-[215px] w-[230px] z-[10] bg-white rounded-tr-[10px] rounded-br-[10px] shadow-lg
    px-[10px] lg:py-[30px] py-[20px] h-full min-h-[100vh]"
    >
      <div className="grid gap-y-[30px]">
        <div className="lg:hidden block">
          <Icons.CrossFilled className="w-[30px] h-[30px] cursor-pointer" onClick={toggleMenu} />
        </div>
        <div className="lg:block hidden">
          <Logo />
        </div>
        <Account />
        <MainNav />
        <Banner position="desktopSide" />
      </div>
    </div>
  );
}
